(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerWrapper = document.querySelector('.header-wrapper');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    
    // Amélioration de la détection de la page produit
    this.isProductPage = window.location.pathname.includes('/products/') || document.body.classList.contains('template-product');

    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    // Logique spéciale pour les pages produits
    if (this.isProductPage) {
      if (scrollTop > this.currentScrollTop && scrollTop > 30) {
        // Scroll vers le bas et on a dépassé 30px
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > 30) {
        // Scroll vers le haut mais toujours au-dessus de 30px

        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= 30) {
        // Retour en haut de page

        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      
      this.currentScrollTop = scrollTop;
      return; // Important: sortir de la fonction pour éviter la logique normale
    }

    // Logique originale pour les autres pages
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.headerWrapper.classList.remove('header-hover-active');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    // Ajouter la classe scrolling-up pour supprimer les transitions
    this.header.classList.add('scrolling-up');
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
    this.headerWrapper.classList.add('header-hover-active');
    
    // Supprimer la classe scrolling-up après l'animation
    setTimeout(() => {
      this.header.classList.remove('scrolling-up');
    }, 50);
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    this.headerWrapper.classList.remove('header-hover-active');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

document.addEventListener('DOMContentLoaded', function() {
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    @media (max-width: 989px) {
      .header {
        position: relative;
        z-index: 10;
      }
      .header::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        height: 100%;
        background: #ffffff;
        z-index: -1;
        pointer-events: none;
        transition: none;
      }
      
      .header .header__menu-item, 
      .header .header__icon,
      .header svg,
      .header .icon {
        position: relative;
        transition: color 0.3s ease, fill 0.3s ease;
      }
      
      .header-white-bg::before {
        width: 100%;
      }
      
      .header-transparent::before {
        width: 0%;
      }
      
      .header-white-bg .header__menu-item,
      .header-white-bg .header__icon,
      .header-white-bg svg,
      .header-white-bg .icon {
        color: rgb(var(--color-neutral)) !important;
        fill: rgb(var(--color-neutral)) !important;
      }

      .menu-drawer[open] ~ .header-wrapper .header,
      .menu-drawer[open] ~ div .header-wrapper .header {
        background-color: #ffffff;
      }
    }
  `;
  document.head.appendChild(styleElement);
  
  const menuDrawerButton = document.querySelector('.header__icon--menu');
  const header = document.querySelector('.header');
  const menuDrawer = document.querySelector('.menu-drawer');
  
  if (menuDrawerButton && header) {
    let menuOpen = false;
    
    function toggleHeaderStyles() {
      if (menuOpen) {
        header.classList.remove('header-white-bg');
        header.classList.add('header-transparent');
      } else {
        header.classList.remove('header-transparent');
        header.classList.add('header-white-bg');
      }
      menuOpen = !menuOpen;
    }
    
    menuDrawerButton.addEventListener('click', toggleHeaderStyles);
    
    // Observer pour le menu drawer
    if (menuDrawer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open') {
            const isOpen = menuDrawer.hasAttribute('open');
            if (isOpen) {
              header.classList.add('header-white-bg');
              header.classList.remove('header-transparent');
              menuOpen = true;
            } else {
              header.classList.remove('header-white-bg');
              header.classList.add('header-transparent');
              menuOpen = false;
            }
          }
        });
      });
      
      observer.observe(menuDrawer, { attributes: true });
    }
  }
  
  window.originalCloseAnnouncement = window.closeAnnouncement || function() {};
  
  window.closeAnnouncement = function() {
    window.originalCloseAnnouncement();
    if (typeof window.updateAnnouncementBarHeight === 'function') {
      window.updateAnnouncementBarHeight();
    } else {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    }
  };
});

  } catch(e) { console.error(e); }
})();
})();
